/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Button, TextField, Box, FormControlLabel, Switch, TableRow, TableCell } from '@mui/material';
import { stateHead } from "../../../../../config/constant";
import { Image, Space } from 'antd';
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg"
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg"
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import crudActions from "../../../../CRUD/redux/actions";
import { NavLink } from "react-router-dom"
import customStyles from "../../../../../assets/styles/customStyles";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { toast } from 'react-toastify';
import usePrevious from "../../../../Shared/components/Previous";
import { emptyValidation } from "../../../../../helpers/validation";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { checkCRUDPermission, getColumnWidth } from "../../../../../helpers/utilities";

export const StateTable = (props) => {
    const { countryDetails, stateDetails, onRequestSort, sortOrder, sortBy,
        loadTasks, loadMore, loadMoreContent, loadMoreTask, customObject, roleManagement } = props;
    const { editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const [visible, setVisible] = useState(false);
    const [stateId, setStateId] = useState(false);
    const [stateName, setStateName] = useState('');
    const [stateShortName, setStateShortName] = useState('');
    const [countryId, setCountryId] = useState('');
    const [country, setCountry] = useState('');
    const [isUtgst, setIsUtgst] = useState(false);

    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [errorStateName, setErrorStateName] = useState(false);
    const [errorStateShortName, setErrorStateShortName] = useState(false);
    const [errorCountryId, setErrorCountryId] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

    const handleClose = () => {
        setVisible(false);
        emptyState();
    };

    const dispatch = useDispatch();

    const onEdit = (data) => {
        setVisible(true);
        setStateId(data.id)
        setStateName(data.name);
        setStateShortName(data.shortName);
        setCountryId(data.countryId);
        setCountry(data.country);
        setIsUtgst(data.isUtgst);
    }


    const onDelete = (data) => {
        setDeleteModal(true);
        setStateId(data.id);
        setStateName(data.name);
    }

    const emptyState = () => {
        setErrorStateName(false);
        setErrorStateShortName(false);
        setErrorCountryId(false);
    }


    const editState = (e) => {
        e.preventDefault();
        let emptyStateName = emptyValidation('State Name', stateName);
        let emptyStateShortName = emptyValidation('Short Name', stateShortName);
        let emptyCountry = emptyValidation('Country', countryId, 'dropDown');
        emptyState();
        if (emptyStateName.isValid && emptyStateShortName.isValid && emptyCountry.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: 'state',
                title: "State",
                id: stateId,
                details: {
                    // name: stateName,
                    shortName: stateShortName,
                    countryId: countryId,
                    isUtgst: isUtgst
                }
            });
        } else {
            if (emptyStateName.errors !== '') {
                setErrorStateName(emptyStateName.errors);
            }
            if (emptyCountry.errors !== '') {
                setErrorCountryId(emptyCountry.errors);
            } if (emptyStateShortName.errors !== '') {
                setErrorStateShortName(emptyStateShortName.errors);
            }
        }
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            setVisible(false);
            toast.dismiss();
            toast(editDetails);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message;
            setErrorStateName(error[1]);
        }
    }, [editDetails, editError]);


    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={stateHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || stateDetails === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        stateDetails && Array.isArray(stateDetails) && stateDetails?.length > 0 ? stateDetails.map((data, i) => (
                                            <TableRow
                                                key={i}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell style={{ width: getColumnWidth(stateHead, 0) }}><span style={{ width: getColumnWidth(stateHead, 0) }}>{data.name}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(stateHead, 1) }}><span style={{ width: getColumnWidth(stateHead, 1) }}>{data.shortName ? data.shortName : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(stateHead, 2) }}><span style={{ width: getColumnWidth(stateHead, 2) }}>{data.country ? data.country.name : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(stateHead, 3) }}><span style={{ width: getColumnWidth(stateHead, 3) }}>{data.isUtgst ? 'Yes' : 'No'}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && (checkCRUDPermission('State', 'edit', 'Younote Admin') || checkCRUDPermission('State', 'edit', 'Admin')) &&
                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                <Image src={EditIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && (checkCRUDPermission('State', 'deletable', 'Younote Admin') || checkCRUDPermission('State', 'deletable', 'Admin')) &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)}>
                                                                <Image src={DeleteIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                <TableCell className={classes.textAlignCenter} colSpan={6}>
                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start Creating State'}</p>

                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Edit State'}
                width={"360px"}
                className={classes.closeBackGround}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => editState(e)}
                    >
                        <div className={classes.customFormFlex}>
                            <TextField autoComplete='one-time-code'
                                label={["State Name ", <span key={"State Name"} className={classes.colorRedRequired}> *</span>]}
                                variant={'standard'}
                                disabled
                                error={errorStateName && true}
                                helperText={errorStateName}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                value={stateName}
                                onChange={(e) => setStateName(e.target.value)}
                            />
                            <TextField autoComplete='one-time-code'
                                label='Short Name'
                                variant={'standard'}
                                className={clsx(classes.margin30t)}
                                error={errorStateShortName && true}
                                helperText={errorStateShortName}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setStateShortName(e.target.value)}
                                value={stateShortName}
                            />
                            <AutoCompleteComponent
                                name={["Country ", <span key={"Country"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                details={countryDetails}
                                parentValue={customObject(countryDetails, countryId)}
                                onChange={(data) => { setCountryId(data.id); setCountry(data) }}
                                position={'bottom'}
                                parentError={errorCountryId}
                                customClasses={classes.margin30t}
                            />
                            {
                                country?.name === 'India' && <FormControlLabel
                                    classes={{
                                        label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                    }}
                                    control={<Switch size='small'
                                        className={clsx(classes.customSwitch)}
                                        onChange={(e) => setIsUtgst(!isUtgst)}
                                        checked={isUtgst}
                                    />}
                                    label="Is Union Territory?"
                                    labelPlacement="top"
                                    className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                />
                            }
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Button
                                key="save"
                                type='submit'
                                color='primary'
                                variant="contained"
                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                            >
                                Update & Save
                            </Button>
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={stateId} loadTasks={() => loadTasks()} name={stateName} url={'state'} title={'State'} visible={deleteModal} />
        </>
    );
}